import {
    Button, Grid, Typography, TextField, Box, Hidden, FormControl, InputLabel, Select
} from "@mui/material";
import { Search as IconSearch, AddCircle as IconAddCircle } from "@mui/icons-material";
import * as salonService from "../../services/salonService";
import * as filialService from "../../services/filialService";
import { useEffect, useState } from "react";
import DataGridBase from "../../components/common/DataGridBase";
import { useMantenimiento } from "../../hooks/useMantenimiento";
import SalonEdit from "../../components/SalonEdit";

// Navegabilidad de salones con su mantenimiento: el boton + registra uno
// nuevo y el codigo, subrayado, abre la edicion.
const Index = () => {
    const { isReadOnly, idFilial, perfilCargado } = useMantenimiento("salon");

    const [filters, setFilters] = useState({ idFilial: 0, descripcion: "" });
    const [filiales, setFiliales] = useState([]);

    const [results, setResults] = useState([]);
    const [cargando, setCargando] = useState(true);

    const [dialog, setDialog] = useState({ open: false, entity: null });
    const openDialog = (entity) => setDialog({ open: true, entity });
    const closeDialog = () => setDialog((d) => ({ ...d, open: false }));

    const fetchResults = async () => {
        setCargando(true);
        try {
            const data = await salonService.getsSalon();
            let list = data || [];
            if (filters.idFilial > 0) list = list.filter((r) => r.idFilial === filters.idFilial);
            if (filters.descripcion && filters.descripcion.trim() !== "") {
                const t = filters.descripcion.toLowerCase();
                list = list.filter((r) => (r.descripcion || "").toLowerCase().includes(t)
                    || (r.codigo || "").toLowerCase().includes(t));
            }
            setResults(list);
        } catch (err) {
            console.log("Err: ", err);
            setResults([]);
        }
        setCargando(false);
    };

    const fetchFiliales = async () => {
        try {
            const data = await filialService.getFilialesList();
            setFiliales(filialService.soloFilialDelUsuario(data, idFilial));
        } catch (err) { console.log("Err: ", err); }
    };

    useEffect(() => {
        fetchResults();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!perfilCargado) return;
        fetchFiliales();
        setFilters((f) => ({ ...f, idFilial: idFilial > 0 ? idFilial : 0 }));
    }, [perfilCargado, idFilial]);

    const estiloClic = {
        cursor: isReadOnly ? 'default' : 'pointer',
        fontSize: 'inherit',
        textDecoration: isReadOnly ? 'none' : 'underline',
    };

    const columns = [
        { field: 'id', headerName: 'ID', width: 50, minWidth: 45, sortable: true, headerAlign: 'center', align: 'center',
            renderCell: (p) => <span style={{ fontSize: '0.75rem', color: '#666', fontFamily: 'monospace' }}>{p.value != null ? p.value : p.row.id}</span> },
        {
            field: 'codigo', headerName: 'Codigo', width: 100, sortable: false, headerAlign: 'left', align: 'center',
            renderCell: (c) => (
                <Typography sx={estiloClic} onClick={isReadOnly ? undefined : () => openDialog(c.row)}>
                    {c.row.codigo}
                </Typography>
            ),
        },
        { field: 'descripcion', headerName: 'Descripcion', width: 260, sortable: false, headerAlign: 'left' },
        { field: 'filial', headerName: 'Filial', width: 160, sortable: false, headerAlign: 'left' },
        { field: 'estado', headerName: 'Estado', width: 100, sortable: false, headerAlign: 'center', align: 'center' },
    ];

    return (
        <div>
            <Grid container>
                <Grid item>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        Salones
                    </Typography>
                </Grid>
                <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                    <Grid item xs={12} sm={12}>
                        <Grid container item xs={12} sm={12} spacing={1}>
                            <Grid item xs={6} sm={3}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-filial" shrink>Filial</InputLabel>
                                    <Select
                                        native
                                        label="Filial"
                                        value={filters.idFilial}
                                        disabled={idFilial > 0}
                                        onChange={(e) => setFilters((f) => ({ ...f, idFilial: parseInt(e.target.value) || 0 }))}
                                        onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); fetchResults(); } }}
                                        inputProps={{ name: 'idFilial', id: 'input-filial' }}
                                        size="small"
                                    >
                                        {idFilial <= 0 && <option key={0} value={0}>{"(Todas)"}</option>}
                                        {filiales.map((row) => (<option key={row.id} value={row.id}>{row.descripcion}</option>))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} sm={4}>
                                <TextField
                                    name="descripcion"
                                    label="Descripcion"
                                    value={filters.descripcion}
                                    fullWidth
                                    onChange={(e) => setFilters((f) => ({ ...f, descripcion: e.target.value }))}
                                    onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); fetchResults(); } }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={4} sm={1} display={"flex"} alignItems={"center"}>
                                <Button variant="outlined" size="medium" fullWidth onClick={fetchResults}>
                                    {<Hidden smDown></Hidden>}
                                    <IconSearch />
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                            <DataGridBase
                                rows={results}
                                columns={columns}
                                loading={cargando}
                                showToolbar={true}
                                toolbarButtons={[
                                    {
                                        text: "Nuevo",
                                        icon: <IconAddCircle />,
                                        disabled: isReadOnly,
                                        onClick: () => openDialog({ id: 0 }),
                                    }
                                ]}
                            />
                        </Box>
                    </Grid>
                </Grid>
                <SalonEdit
                    open={dialog.open}
                    openClose={closeDialog}
                    entity={dialog.entity}
                    setNewSaved={fetchResults}
                    isReadOnly={isReadOnly}
                />
            </Grid>
        </div>
    );
};

export default Index;
